/**
 * @see https://bytedance.sg.larkoffice.com/docx/HWFKdIr5honItyxDOUglWd8rgWX
 * @see https://bytedance.larkoffice.com/wiki/wikcnbcycVBhgOkzajrdNtX5x3d
 * @see https://bytedance.larkoffice.com/wiki/Y3Q7wnwwGi0d9NkBWEOcZAs4nNf
 */
// @ts-ignore
import { _filterXSS } from '@ies/filter-xss/dist/blackForModule.umd';
export const filterXSS = (html) => _filterXSS(html, null, { mode: 'black', block: true });
export const buildInnerHtml = (html) => {
    return {
        __html: filterXSS(html),
    };
};
